import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const WorkkardDetailSec1tLoader = props => {
        return(<>
      {props.count && props.count > 0 && (
                    Array.from({ length: props.count }, (_, i) => (
                        <ContentLoader 
                        rtl
                        width={418}
                        speed={2}
                        key={i+1}
                        height={134}
                    >
                        <rect x="9.84" y="16.67" rx="8" ry="8" width="81" height="12" /> 
                        <rect x="101.84" y="16.64" rx="8" ry="8" width="56.7" height="12" /> 
                        <rect x="8.84" y="35.67" rx="8" ry="8" width="149" height="12" /> 
                        <rect x="10.84" y="81.67" rx="8" ry="8" width="122" height="12" /> 
                        <rect x="9.84" y="100.67" rx="8" ry="8" width="257" height="12" />
                    </ContentLoader>
                    ))
                )}</>)
    }
 